import { render, staticRenderFns } from "./product-variants-dimensions-modal.vue?vue&type=template&id=22b4a42f&"
import script from "./product-variants-dimensions-modal.vue?vue&type=script&lang=js&"
export * from "./product-variants-dimensions-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports